import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function ZoomFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Experience the convenience of Zoom meetings in Nutshell'
            subHeader='Connect Nutshell to your Zoom account for seamless collaboration'
            bullets={[
                'Gain valuable insights with AI-generated summaries for all of your recorded Zoom meetings.',
                'Seamlessly track meeting history with automatic timeline entries',
                'Access recordings and read meeting transcriptions, all within Nutshell.',
            ]}
            feature='zoom'
        />
    );
}
